document.addEventListener('DOMContentLoaded', () => {
  const productBar = document.querySelector('[data-mobile-product-bar]');
  const mainSubmit = document.querySelector('.main-product .product-form button[type="submit"]');
  const barSubmit = productBar?.querySelector('[data-mobile-product-submit]');
  if (productBar && mainSubmit && barSubmit) {
    const sync = () => {
      barSubmit.disabled = mainSubmit.disabled;
      barSubmit.textContent = mainSubmit.textContent.trim();
    };
    sync();
    barSubmit.addEventListener('click', () => mainSubmit.click());
    mainSubmit.closest('form')?.addEventListener('change', () => requestAnimationFrame(sync));
    let buttonVisible = true;
    let sectionVisible = true;
    const updateVisibility = () => { productBar.hidden = buttonVisible || !sectionVisible; };
    const buttonObserver = new IntersectionObserver(([entry]) => {
      buttonVisible = entry.isIntersecting;
      updateVisibility();
    }, { threshold: 0.2 });
    const sectionObserver = new IntersectionObserver(([entry]) => {
      sectionVisible = entry.isIntersecting;
      updateVisibility();
    });
    buttonObserver.observe(mainSubmit);
    sectionObserver.observe(productBar.closest('section'));
  }

  const filters = document.querySelector('[data-mobile-filters]');
  if (filters) {
    const close = () => { filters.open = false; filters.querySelector('summary')?.focus(); };
    filters.querySelectorAll('[data-filter-close]').forEach(button => button.addEventListener('click', close));
    filters.addEventListener('toggle', () => document.body.classList.toggle('mobile-filters-open', filters.open));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && filters.open) close();
    });
  }
});

